import { render, staticRenderFns } from "./shiporders.vue?vue&type=template&id=5cf9f9ba&"
import script from "./shiporders.vue?vue&type=script&lang=js&"
export * from "./shiporders.vue?vue&type=script&lang=js&"
import style0 from "./shiporders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports